// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarDropdownItems(Props) {
  let item = Props.item;
  let setIdx = Props.setIdx;
  let setMobileMenuActive = Props.setMobileMenuActive;
  const countryStr = Buhta_models__Locale.toCountryString(Buhta_landing__Route.getCountry(undefined));
  const languageStr = Buhta_models__Locale.toString(Buhta_landing__Route.getLanguage(undefined));
  const list = item.menu_items;
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("p", {
        children: [
          JsxRuntime.jsx("img", {
            className: "inline mr-2",
            alt: "arrow back",
            src: StaticAsset.src("/static/icons/arrow-back.svg")
          }),
          item.name
        ],
        className: "paragraph-small text-gray-landing py-3.5 mb-2 border-b border-divider",
        onClick: (function (param) {
          Curry._1(setIdx, (function (param) {
            return -1;
          }));
        })
      }),
      Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, s) {
        const route = "/" + countryStr + "/" + languageStr + s.path;
        const Key = "list_item_" + String(index);
        return JsxRuntime.jsxs(Buhta_landing__Link.make, {
          route: Buhta_landing__Route.ofUrl(Buhta_landing__Route.getRouterUrl(route)),
          className: "flex items-center",
          onLinkClicked: (function (param) {
            Curry._1(setMobileMenuActive, (function (param) {
              return false;
            }));
          }),
          children: [
            JsxRuntime.jsx("img", {
              className: "navbar-dropdown-item-img shrink-0 w-14",
              alt: "buhta",
              src: s.icon
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                  children: s.title,
                  className: "paragraph-medium text-black-landing hover"
                }),
                JsxRuntime.jsx("p", {
                  children: s.subtitle,
                  className: "paragraph-small text-gray-landing hover"
                })
              ],
              className: "ml-4 border-b border-divider py-2 grow min-h-18"
            })
          ]
        }, Key);
      }), Stdlib__List.sort((function (a, b) {
        return a.order - b.order | 0;
      }), list)))
    ]
  });
}

const make = NavbarDropdownItems;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
